







import { Component, Prop, Vue } from "vue-property-decorator";
import * as Enumerable from "linq-es5";

import * as def from "@/definitions";

const isElement = (x: any): x is HTMLInputElement =>
  x instanceof HTMLInputElement;
@Component({
  components: {}
})
export default class Knob extends Vue {
  @Prop()
  gradientColor!: {
    id: number;
    color: string;
    position: number;
    isSelected: boolean;
    isRangeVisible: boolean;
  };

  get knobStyle() {

    if (this.gradientColor.isSelected) {
      return {
          width: "8%",
          background: "transparent",
          left: this.gradientColor.position / 100 * 92 + "%",
          border: "solid 1px #ffffff",
          height: "calc(100% - 2px)"
        };
    } else {
      return {
          width: "4%",
          background: "#ffffff",
          left: this.gradientColor.position / 100 * 96 + "%"
        };
    }
  }

  selectGradientColor(event: MouseEvent) {
    this.$emit("selectGradientColor", this.gradientColor.id, event.clientX);
  }
}
